import { useQuery, queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";

export const listListedPartsQuery = () => {
  return queryOptions({
    queryKey: ["parts", "listed"],
    queryFn: async () => {
      return handleClientMethod(getClient().GET("/parts/listed", {}));
    },
  });
};

export const useListListedParts = () => {
  return useQuery(listListedPartsQuery());
};
